<script>
    import { ValueService } from '../../services/ValueService.js';
    import LySection from './LySection.svelte';

    /**
     * @type {{
     *     src?: string|null,
     *     alt?: string|null,
     *     mt?: number | boolean | string,
     *     mb?: number | boolean | string,
     * }}
     */
    let { src = null, alt = null, mt = 0, mb = 0 } = $props();

    let thisAlt = $derived(ValueService.toStringSingleLine(alt ?? ''));
</script>

<LySection tag="figure" {mt} {mb}>
    <picture class="m-0 block p-0">
        <img {src} alt={thisAlt} class="m-0 block h-auto w-full p-0" />
    </picture>
</LySection>
